import { CompareValuesPerYearPerMonth } from './CompareValuesPerYearPerMonth';
import { SimpleChartIncrease } from './SimpleChart';

export const CompareCharts = () => {
    return (
        <>
            <CompareValuesPerYearPerMonth />
            <SimpleChartIncrease />
        </>
    );
};
